import { RouteNamesEnum } from '@/enums/RouteNamesEnum';

const ListsRoutes = [
    {
        path: '/lists',
        component: () => import('../components/general/RootModule.vue'),
        meta: {
            title: 'ListsModule.module-name',
            icon: 'mdi-list-box-outline',
            auth: {
                required: true,
            },
            showInMenu: true,
            moduleRoot: true,
        },
        children: [
            {
                path: '',
                redirect: '/lists/producers',
            },
            {
                path: 'producers/:id(\\d+|new)?',
                name: RouteNamesEnum.Producers,
                component: () => import('../views/lists-module/ProducersView.vue'),
                meta: {
                    title: 'ListsModule.producers',
                    auth: {
                        required: true,
                    },
                    showInMenu: true,
                    isArchive: false,
                    dontShiftMe: true,
                },
            },
            {
                path: 'types/:id(\\d+|new)?',
                name: RouteNamesEnum.Types,
                component: () => import('../views/lists-module/TypesView.vue'),
                meta: {
                    title: 'ListsModule.types',
                    auth: {
                        required: true,
                    },
                    showInMenu: true,
                    isArchive: false,
                    dontShiftMe: true,
                },
            },
            {
                path: 'names/:id(\\d+|new)?',
                name: RouteNamesEnum.Names,
                component: () => import('../views/lists-module/NamesView.vue'),
                meta: {
                    title: 'ListsModule.names',
                    auth: {
                        required: true,
                    },
                    showInMenu: true,
                    isArchive: false,
                    dontShiftMe: true,
                },
            },
            {
                path: 'units/:id(\\d+|new)?',
                name: RouteNamesEnum.Units,
                component: () => import('../views/lists-module/UnitsView.vue'),
                meta: {
                    title: 'ListsModule.units',
                    auth: {
                        required: true,
                    },
                    showInMenu: true,
                    isArchive: false,
                    dontShiftMe: true,
                },
            },
            {
                path: 'probe-reads/:id(\\d+|new)?',
                name: RouteNamesEnum.ProbeReads,
                component: () => import('../views/lists-module/ProbeReadsView.vue'),
                meta: {
                    title: 'ListsModule.probe-reads',
                    auth: {
                        required: true,
                    },
                    showInMenu: true,
                    isArchive: false,
                    dontShiftMe: true,
                },
            },
            {
                path: 'probe-types/:id(\\d+|new)?',
                name: RouteNamesEnum.ProbeTypes,
                component: () => import('../views/lists-module/ProbeTypesView.vue'),
                meta: {
                    title: 'ListsModule.probe-types',
                    auth: {
                        required: true,
                    },
                    showInMenu: true,
                    isArchive: false,
                    dontShiftMe: true,
                },
            },
        ],
    },
];

export default ListsRoutes;
